import { StyleFn } from './index'

export type StylesKeys = 'time'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  time: StyleFn
}

export const defaultStyles: Styles = {
  time: () => ({
    fontSize: '0.8em',
    whiteSpace: 'nowrap',
    justifySelf: 'center',
    gridArea: 'tim',
  }),
}
